// Note: prid and catalog can be string or number, it's why we use loose comparison
// Note: return null if no wishlist match
export default (wishlists, prid, catalog) =>
  wishlists.find(({ itemsDetails }) =>
    itemsDetails.find(({ Prid, Catalog }) => String(Prid) === prid && String(Catalog) === catalog)
  ) || null;
